import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { MenuItem } from '@material-ui/core';

import { FeedKey } from 'api';
import { FollowToggle, IFollowToggleRenderProps } from 'components';
import { useContent, useNotify } from 'hooks';
import { getFullName } from 'helpers';

interface IProps {
  onClose: () => void;
}

const UserFollowToggle: FC<IProps> = ({ onClose }) => {
  const { t } = useTranslation();
  const content = useContent();
  const notify = useNotify();

  function getMenuKey(isFollowing: boolean) {
    return isFollowing ? 'content:postUnfollow' : 'content:postFollow';
  }

  function getNotifyKey(isFollowing: boolean) {
    return isFollowing ? 'content:postUnfollowed' : 'content:postFollowed';
  }

  function getCreatorName() {
    return getFullName(content.user);
  }

  function handleClick(renderProps: IFollowToggleRenderProps) {
    const { isFollowing } = renderProps;

    const notifyKey = getNotifyKey(isFollowing);
    const name = getCreatorName();

    notify.info({ i18n: { i18nKey: notifyKey, values: { name } } });
    onClose();
  }

  return (
    <FollowToggle source={content.user} type={FeedKey.User}>
      {followToggleRenderProps => {
        const i18nKey = getMenuKey(followToggleRenderProps.isFollowing);
        const name = getCreatorName();

        return (
          <MenuItem onClick={() => handleClick(followToggleRenderProps)}>
            {t(i18nKey, { name })}
          </MenuItem>
        );
      }}
    </FollowToggle>
  );
};

export default UserFollowToggle;
